<template>
  <div v-if="task">
    <task-body :task="task" :try-join="tryJoin" :try-leave="tryLeave" />
    <box class="pb-4">
      <h2 class="mb-5">Rewards</h2>
      <rewards-list :type="task.title" :rewards="task.subTasks" />
    </box>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';
import RewardsList from '@/views/Campaign/BountyCampaign/components/RewardsList.vue';

export default {
  mixins: [taskMixin],

  components: {
    RewardsList
  }
};
</script>
